<script lang="ts" setup>
import { onMounted, ref, useAuth, useI18n } from '#imports';
import MPCreatorOnboarding from './MPCreatorOnboarding.vue';
import MPLogin from './MPLogin.vue';
import MPSignUp from './MPSignUp.vue';
import MPUserOnboarding from './MPUserOnboarding.vue';

const props = defineProps({
  login: {
    type: Boolean,
    default: false,
  },
  showLogo: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'Login or Join',
  },
  summary: {
    type: String,
    default: 'Access Bookmarks, Members only content, and more',
  },
  startOn: {
    type: String,
    default: 'login',
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  userType: {
    type: String,
    default: 'user',
  },
});

// auth step
const authStep = ref('login');
if (props.startOn) authStep.value = props.startOn;
const toggleAuthStep = () => {
  authStep.value = authStep.value === 'login' ? 'signup' : 'login';
};

const { t } = useI18n();

const onboarding = ref(false);

const { currentUser } = useAuth();
onMounted(() => {
  if (currentUser.value) onboarding.value = true;
});
</script>

<template>
  <div v-if="!onboarding" class="authentication-form">
    <div v-if="props.showLogo" class="auth-logo">
      <img src="/images/logo-square.png" width="80px">
    </div>
    <h4 v-if="props.title" class="auth-title">
      {{ props.title }}
    </h4>
    <div v-if="props.summary" class="auth-summary">
      {{ props.summary }}
    </div>
    <div v-if="authStep === 'login'">
      <MPLogin @toggle-auth-step="toggleAuthStep"/>
    </div>
    <div v-if="authStep === 'signup'">
      <MPSignUp @toggle-auth-step="toggleAuthStep" @start-onboarding="onboarding = true"/>
    </div>
  </div>
  <div v-else>
    <div v-if="props.userType === 'user'">
      <MPUserOnboarding />
    </div>
    <div v-else>
      <MPCreatorOnboarding />
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.authentication-form {
  max-width: 20rem;
  margin: 0 auto;
  padding: 1rem;
  display: grid;
  gap: 1rem;
  text-align: center;
}

.login {
  display: grid;
  gap: 1rem;
}

.auth-title {
  text-align: center;
  font-size: 1.5rem;
  font-weight: 500;
  color: var(--color-slate-800);
  margin: 0.5rem 0 0 0;
}

.auth-summary {
  color: var(--color-slate-400);
  margin-bottom: 0.75rem;
}
</style>
